<div class="title">
    {{ "widget_product_filter_price_settings" | translate | uppercase }}
</div>

<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "catalog_filter_category_label" | translate }}
        </label>
        <div class="col-xs-12 mb-5">
            <input class="form-control" [formControl]="label" />
        </div>
        <div class="col-xs-4">
            <sp-input-num
                suffixText="px"
                [min]="FONT_SIZE_MIN"
                [max]="FONT_SIZE_MAX"
                [onlyIntegers]="true"
                [value]="priceLabelFontFormGroup.controls.fontSize.value"
                (valueChange)="setFontSize($event)"
            ></sp-input-num>
        </div>
        <div class="col-xs-6 mb-10">
            <div class="btn-group btn-group-justified" data-toggle="buttons">
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(EFontStyle.AT)"
                    (click)="toggleActiveTextStyle(EFontStyle.AT)"
                >
                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(EFontStyle.B)"
                    (click)="toggleActiveTextStyle(EFontStyle.B)"
                >
                    <img src="./assets/img/lpc-icon-bold.svg" alt="AT" />
                </label>
                <label
                    class="btn btn-grey"
                    [class.active]="isActiveTextStyle(EFontStyle.I)"
                    (click)="toggleActiveTextStyle(EFontStyle.I)"
                >
                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                </label>
            </div>
        </div>
        <div class="col-xs-2">
            <sp-color-picker
                hideGradient
                [color]="priceLabelFontFormGroup.controls.color.value"
                (colorChangeEvent)="setLabelTextColor($event)"
            >
            </sp-color-picker>
        </div>
    </div>
    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_fields_appearance" | translate }}
        </label>
        <div class="col-xs-12">
            <div class="btn-group d-flex">
                <button
                    class="btn btn-grey w-100"
                    [class.active]="borderStyle.value === inputBorderEnum.FULL_BORDER"
                    (click)="setBorderStyle(inputBorderEnum.FULL_BORDER)"
                >
                    <img src="./assets/img/websites/lpc-full-border-icon.svg" alt="center-icon" />
                </button>
                <button
                    class="btn btn-grey w-100"
                    [class.active]="borderStyle.value === inputBorderEnum.BOTTOM_BORDER"
                    (click)="setBorderStyle(inputBorderEnum.BOTTOM_BORDER)"
                >
                    <img src="./assets/img/websites/lpc-bottom-border-icon.svg" alt="left-icon" />
                </button>
            </div>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_input_text_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker [color]="textColor.value" (colorChangeEvent)="setTextColor($event)"></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_background_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="backgroundColor.value"
                (colorChangeEvent)="setBackgroundColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_border_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker [color]="borderColor.value" (colorChangeEvent)="setBorderColor($event)"></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-6 control-label">
            {{ "control_radius" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                prefixImgUrl="./assets/img/border-radius-icon.svg"
                suffixText="px"
                [min]="BORDER_RADIUS_MIN"
                [max]="BORDER_RADIUS_MAX"
                [onlyIntegers]="true"
                [value]="borderRadius.value"
                (valueChange)="setBorderRadius($event)"
                (blurEvent)="setBorderRadius($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-6 control-label">{{ "control_fields_size" | translate }}</label>
        <div class="col-xs-6">
            <sp-radio-group
                [selected]="inputSize.value"
                [type]="ERadioGroupType.size"
                (changeSelectedEvent)="setInputSize($event)"
            ></sp-radio-group>
        </div>
    </div>

    @if (catalogView === CatalogCategoriesView.left) {
        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_slider_label" | translate }}
            </label>
            <div class="col-xs-3 text-right">
                <sp-switch [active]="slider.value" (toggleActiveEvent)="setEnabledSlider($event)"></sp-switch>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_line_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker [color]="colorLine.value" (colorChangeEvent)="setColorLine($event)"></sp-color-picker>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_filled_line_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="colorFilledLine.value"
                    (colorChangeEvent)="setColorFilledLine($event)"
                ></sp-color-picker>
            </div>
        </div>
        <div class="form-group mb-0">
            <label class="col-xs-9 control-label">
                {{ "control_button_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="colorButtons.value"
                    (colorChangeEvent)="setColorButtons($event)"
                ></sp-color-picker>
            </div>
        </div>
    }
</div>
